import {axios} from "../plugins/http-axios";
import {Module} from "vuex";
import {RootState} from "@/store/index";
export interface I18n{
    [key:string]:string
}
interface I18nState{
    i18n: I18n;
    i18nLkk: I18n;
    i18nBank: I18n,
}
export default <Module<I18nState, RootState>>{
    state:{
        i18n: {},
        i18nBank: {},
        i18nLkk: {},
    },
    mutations:{
        setI18n(state, data:I18n={}) {
            state.i18n = data;
        },
        setI18nBank(state, data:I18n={}) {
            state.i18nBank = data;
        },
        setI18nLkk(state, data:I18n={}) {
            state.i18nLkk = data;
        },

    },
    actions:{
        getI18n({commit, dispatch, rootGetters}):Promise<void> {
            return axios.get(rootGetters.uri.infoSystemInfoLogin)
                .then(resp => {
                    const data = {
                        ...resp.data.i18n,
                        version: resp.data.version
                    };
                    // localStorage.setItem('i18n', JSON.stringify(data));
                    commit('setI18n', data);
                    return Promise.resolve();
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
        getI18nLkk({getters, commit, dispatch, rootGetters, state}):Promise<I18n> {
            if (getters.isI18nLkk)
                return Promise.resolve(state.i18nLkk);

            return axios.get<I18n>(rootGetters.uri.i18nLkk)
                .then(resp => {
                    commit('setI18nLkk', resp.data);
                    return resp.data;
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
    },
    getters:{
        isI18nLkk: (state):boolean => !!Object.keys(state.i18nLkk).length,
        voc: (state):I18n => {
            return {...state.i18n, ...state.i18nBank, ...state.i18nLkk};
        },
        i18n: (state):I18n => state.i18n,
    },
};
